import React, { Component } from 'react';
import { FormModal, Input } from '@shootsta/common-react';

type RenameConfirmationModalProps = {
  visible: boolean;
  updateVideoAtomic: any;
  onConfirmation: any;
  onClose: any;
  video?: Video;
};

type RenameConfirmationModalState = {
  name: string;
};

const initialState = {
  name: ''
} as const;

export default class RenameConfirmationModal extends Component<
  RenameConfirmationModalProps,
  RenameConfirmationModalState
> {
  constructor() {
    super();
    this.state = { ...initialState };
  }

  componentDidUpdate(prevProps: RenameConfirmationModalProps) {
    const { video } = this.props;

    if (prevProps.video && !video) {
      this.resetState();
    }
  }

  resetState = () => {
    this.setState({ ...initialState });
  };

  handleOnSave = async () => {
    const { video, updateVideoAtomic, onConfirmation } = this.props;
    const { name } = this.state;

    if (!video) {
      return null;
    }

    const { data, error } = await updateVideoAtomic({
      input: {
        type: 'ADD',
        value: name,
        fieldName: 'name'
      },
      videoId: video.videoId
    });

    this.resetState();

    if (!data || error) {
      return null;
    }

    return onConfirmation();
  };

  handleOnClose = () => {
    const { onClose } = this.props;
    this.resetState();
    onClose();
  };

  render() {
    const { visible, video } = this.props;
    const { name } = this.state;

    if (!video) {
      return null;
    }

    return (
      <FormModal
        visible={visible}
        onClose={this.handleOnClose}
        onSave={this.handleOnSave}
        title="Rename Project Title"
        saveText="Save Changes"
        saveDisabled={!name.length}
      >
        <Input
          placeholder="Project Title"
          value={name}
          onChange={({ target: { value } }) => this.setState({ name: value })}
        />
      </FormModal>
    );
  }
}
